import { useContacts } from '@/hooks/useContacts';
import { useRentalInfo } from '@/hooks/useRentalInfo';
import { HOUSEHOLD_FAMILY_NOTE } from '@shared/household-notes';
// LeaseCard removed from the rendered page at user request; the component
// file is retained so the lease upload/view/download flow can be reinstated
// with a one-line import.
import { ContactCard } from '@/components/ContactCard';

export function RentalPage() {
  const { contacts } = useContacts();
  const { info, homeAddress } = useRentalInfo();

  const realtor = contacts.find((c) => c.category === 'realtor');
  const landlord = contacts.find((c) => c.category === 'landlord');
  const propertyManager = contacts.find((c) => c.category === 'property_manager');
  const maintenance = contacts.find((c) => c.category === 'maintenance');
  const babcockNational = contacts.filter((c) => c.category === 'babcock_national');

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Our Rental</h1>
        {homeAddress && <p className="page-subtitle">{homeAddress}</p>}
      </div>

      {realtor && <ContactCard contact={realtor} id="beth" />}
      {landlord && <ContactCard contact={landlord} id="landlord" />}
      {propertyManager && <ContactCard contact={propertyManager} />}
      {maintenance && <ContactCard contact={maintenance} id="maintenance" />}

      {babcockNational.length > 0 && (
        <>
          <div className="section-title">Babcock National Contacts</div>
          {babcockNational.map((c) => (
            <ContactCard key={c.id} contact={c} />
          ))}
        </>
      )}

      <div className="card" id="house">
        <h2>House Information</h2>
        <div className="note-block">
          <div className="note-label">{HOUSEHOLD_FAMILY_NOTE.label}</div>
          {HOUSEHOLD_FAMILY_NOTE.body}
        </div>
        {info.length === 0 && (
          <p style={{ color: 'var(--color-ink-muted)', fontSize: 14 }}>No other house details saved yet.</p>
        )}
        {info.map((item) => (
          <div key={item.key} className="list-row">
            <span style={{ color: 'var(--color-ink-muted)' }}>{item.label}</span>
            <span style={{ textAlign: 'right', maxWidth: '60%' }}>{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
